<template>
  <v-container fluid grid-list-xl>
    <v-layout wrap align-start>
      <!-- <v-flex sm2 d-flex>
        <v-select
          v-model="filters.status"
          item-text="title"
          :items="statuses"
          item-value="value"
          label="Status"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.status.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllStatuses">
              <v-list-item-action>
                <v-icon
                  :color="filters.status.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ statusIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex> -->
      <v-flex sm2 d-flex>
        <v-select
          v-model="filters.status"
          :items="statuses"
          item-text="title"
          item-value="id"
          label="Status"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.title }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.status.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllStatuses">
              <v-list-item-action>
                <v-icon
                  :color="
                    filters.status.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ statusIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-select
          v-model="filters.lead"
          :items="leads"
          item-text="fullname"
          item-value="lead_id"
          label="Lead Name"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.fullname }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.lead.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllLeads">
              <v-list-item-action>
                <v-icon
                  :color="filters.lead.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ leadIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex v-if="user.role_id === 1">
        <v-select
          v-model="filters.user"
          :items="users"
          item-text="agentName"
          item-value="user_id"
          label="Agent Name"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.agentName }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.user.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllUsers">
              <v-list-item-action>
                <v-icon
                  :color="filters.user.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ userIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-select
          v-model="filters.dateTime"
          :items="dates"
          item-text="datetime"
          item-value="datetime_old"
          label="Date/Time"
          @change="filter"
          chips
          multiple
          dense
          solo
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.datetime }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption">
              (+{{ filters.dateTime.length - 1 }})
            </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="selectAllDateTimes">
              <v-list-item-action>
                <v-icon
                  :color="filters.dateTime.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ dateTimeIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm2 d-flex>
        <v-btn height="40" depressed @click="clearFilters">
          Clear filters
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "FollowupsTableFilters",
  props: {
    user: Object,
  },
  computed: {
    ...mapGetters({
      followups: "followups/user_followups",
      filtered_followups: "followups/filtered_followups",
      filters: "filters/followUpFilters",
      statuses: "statuses/statuses",
      leads: "followups/leads",
      dates: "followups/dates",
      users: "followups/users",
    }),
    statusIcon() {
      if (this.filters.status.length === this.statuses.length)
        return "mdi-close-box";
      if (
        this.filters.status.length < this.statuses.length &&
        this.filters.status.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    leadIcon() {
      if (this.filters.lead.length === this.leads.length)
        return "mdi-close-box";
      if (
        this.filters.lead.length < this.leads.length &&
        this.filters.lead.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    userIcon() {
      if (this.filters.user.length === this.users.length)
        return "mdi-close-box";
      if (
        this.filters.user.length < this.users.length &&
        this.filters.user.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    dateTimeIcon() {
      if (this.filters.dateTime.length === this.dates.length)
        return "mdi-close-box";
      if (
        this.filters.dateTime.length < this.dates.length &&
        this.filters.dateTime.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapMutations({
      SET_FOLLOWUP_STATUS_FILTER: "filters/SET_FOLLOWUP_STATUS_FILTER",
      SET_FOLLOWUP_LEAD_FILTER: "filters/SET_FOLLOWUP_LEAD_FILTER",
      SET_FOLLOWUP_DATETIME_FILTER: "filters/SET_FOLLOWUP_DATETIME_FILTER",
      SET_FOLLOWUP_USER_FILTER: "filters/SET_FOLLOWUP_USER_FILTER",
    }),
    ...mapActions({
      loadFollowupsByFilters: "followups/loadFollowupsByFilters",
      loadUserFollowups: "followups/loadUserFollowups",
      loadStatuses: "statuses/loadStatuses"
    }),
    filter() {
      this.SET_FOLLOWUP_STATUS_FILTER(this.filters.status);
      this.SET_FOLLOWUP_LEAD_FILTER(this.filters.lead);
      this.SET_FOLLOWUP_DATETIME_FILTER(this.filters.dateTime);
      this.SET_FOLLOWUP_USER_FILTER(this.filters.user);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    selectAllStatuses() {
      if (this.filters.status.length === this.statuses.length) {
        this.filters.status = [];
      } else {
        this.setAllStatuses();
      }
      this.SET_FOLLOWUP_STATUS_FILTER(this.filters.status);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    selectAllLeads() {
      if (this.filters.lead.length === this.leads.length) {
        this.filters.lead = [];
      } else {
        this.setAllLeads();
      }
      this.SET_FOLLOWUP_LEAD_FILTER(this.filters.lead);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    selectAllUsers() {
      if (this.filters.user.length === this.users.length) {
        this.filters.user = [];
      } else {
        this.setAllUsers();
      }
      this.SET_FOLLOWUP_USER_FILTER(this.filters.user);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    selectAllDateTimes() {
      if (this.filters.dateTime.length === this.dates.length) {
        this.filters.dateTime = [];
      } else {
        this.setAllDateTimes();
      }
      this.SET_FOLLOWUP_DATETIME_FILTER(this.filters.dateTime);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    clearFilters() {
      this.setAllStatuses();
      this.setAllLeads();
      this.setAllUsers();
      this.setAllDateTimes();

      this.SET_FOLLOWUP_STATUS_FILTER(this.filters.status);
      this.SET_FOLLOWUP_LEAD_FILTER(this.filters.lead);
      if (this.user.role_id === 1) {
        this.SET_FOLLOWUP_USER_FILTER(this.filters.user);
      } else {
        this.SET_FOLLOWUP_USER_FILTER([this.user.id]);
      }
      this.SET_FOLLOWUP_DATETIME_FILTER(this.filters.dateTime);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    },
    setAllStatuses() {
      this.filters.status = [];
      this.statuses.forEach((status) => {
        this.filters.status.push(status.id);
      });
    },
    setAllLeads() {
      this.filters.lead = [];
      this.leads.forEach((lead) => {
        this.filters.lead.push(lead.lead_id);
      });
    },
    setAllUsers() {
      this.filters.user = [];
      this.users.forEach((user) => {
        this.filters.user.push(user.user_id);
      });
    },
    setAllDateTimes() {
      this.filters.dateTime = [];
      this.dates.forEach((date) => {
        this.filters.dateTime.push(date.datetime_old);
      });
    },
  },
  mounted() {
    this.loadStatuses();
    this.loadUserFollowups(this.user.id).then(() => {
      if (!localStorage.getItem("followUpFilters")) {
        this.clearFilters();
      }

      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });

      this.setAllStatuses();
      this.setAllLeads();
      this.setAllUsers();
      this.setAllDateTimes();

      this.SET_FOLLOWUP_STATUS_FILTER(this.filters.status);
      this.SET_FOLLOWUP_LEAD_FILTER(this.filters.lead);
      if (this.user.role_id === 1) {
        this.SET_FOLLOWUP_USER_FILTER(this.filters.user);
      } else {
        this.SET_FOLLOWUP_USER_FILTER([this.user.id]);
      }
      
      this.SET_FOLLOWUP_DATETIME_FILTER(this.filters.dateTime);
      this.loadFollowupsByFilters({
        params: this.filters,
        user_id: this.user.id,
      });
    });
  },
};
</script>

<style scoped>
</style>